import { GrOrganization } from "react-icons/gr";

export const enDashboardTranslations = {
  dashboard: {
    // Dashboard page
    title: "Dashboard",
    subtitle: "Overview of your restaurant activity",
    totalViews: "Total Menu Views",
    totalOrders: "Total Orders",
    activeCustomers: "Active Customers",
    totalRevenue: "Total Revenue",
    menuCategories: "Menu Categories",
    addCategory: "Add Category",
    popularItems: "Popular Items",
    recentOrders: "Recent Orders",

    // Empty states
    noCategoriesYet: "No categories yet",
    noOrdersYet: "No orders yet",
    createFirstCategory: "Create your first category",

    // Charts
    viewsLabel: "Views",
    ordersLabel: "Orders",
    last7Days: "Last 7 Days",
    last30Days: "Last 30 Days",
    thisMonth: "This Month",
    lastMonth: "Last Month",

    // Quick actions
    quickActions: "Quick Actions",
    newMenuItem: "New Menu Item",
    viewWebsite: "View Website",
    viewAnalytics: "View Analytics",

    topCustomers: "Top Customers",
    viewAllCustomers: "View All Customers",
    viewAll: "View All",

    dashboard: "Dashboard",
    welcomeTo: "Welcome to {{name}}",
    overview: "Here's an overview of your branch",
    totalItems: "Menu Items",
    categories: "Categories",
    mainCategories: "Main Categories",
    subCategories: "Sub Categories",
    orders: "Orders",
    customers: "Customers",
    manageCategories: "Manage Categories",
    manageCategoriesDesc: "Create and organize your menu categories",
    manageMenu: "Manage Menu Items",
    manageMenuDesc: "Add and update your menu items",
    viewAnalyticsDesc: "View insights about your menu performance",

    publishChanges: "Publish Changes",
    publishSuccess: "Menu published successfully!",
    publishError: "Failed to publish menu. Please try again.",

    agentSettings: "Agent Settings",
    agentSettingsDesc: "Configure AI assistant and automation settings",
    settings: "Settings",
    settingsDesc: "Manage restaurant settings and preferences",
    viewMenu: "View Menu",
    viewMenuDesc: "Preview your public menu as customers see it",
  },

  branches: {
    title: "Branches",
    subTitle: "Manage your restaurant branches",
    createBranch: "Create Branch",
    createFirstBranch: "Create Your First Branch",
    manageBranches: "Manage Branches",
    noBranches: "You don't have any branches yet",
    untitled: "Untitled Branch",
    manage: "Manage Branch",
    view: "View Menu",
    edit: "Edit Branch",
    delete: "Delete Branch",
    select: "Select Branch",
    change: "Change Branch",
    fetchError: "Failed to fetch branches. Please try again.",

    optional: "optional",
    logoSelected: "Logo selected",
    uploading: "Uploading...",
    supportedFormats: "PNG, JPG, WebP, GIF up to 5MB",
    namePlaceholder: "Enter branch name (e.g., Downtown Location)",
    descriptionPlaceholder:
      "Describe this branch location and any unique features...",
    createNew: "Create New Branch",
    name: "Branch Name",
    description: "Description",
    logo: "Logo",
    uploadLogo: "Click to upload logo or drag and drop",
    create: "Create Branch",

    clone: "Clone Branch",
    copy: "Copy",
    cloning: "Cloning...",
    cloneError: "Failed to clone branch. Please try again.",
    cloneSuccess: "Branch cloned successfully",

    deleting: "Deleting...",
    deleteError: "Failed to delete branch. Please try again.",
    deleteSuccess: "Branch deleted successfully",

    // Modals and confirmations
    deleteTitle: "Delete Branch",
    deleteMessage:
      'Are you sure you want to delete "{{name}}"? This action cannot be undone.',
    deleteConfirmation:
      'Are you sure you want to delete "{{name}}"? This will also delete all data in this branch. This action cannot be undone.',

    errors: {
      nameRequired: "Branch name is required",
      createFailed: "Failed to create branch. Please try again.",
      invalidFileType: "Invalid file type. Only images are allowed.",
      fileTooLarge: "File is too large. Maximum size is 5MB.",
    },
  },

  sidebar: {
    dashboard: "Dashboard",
    menu: "Menu Items",
    categories: "Categories",
    tableManagement: "Table Management",
    orders: "Orders",
    customers: "Customers",
    dietaryPreferences: "Dietary Preferences",
    variants: "Variants",
    analytics: "Analytics",
    settings: "Settings",
    newMenuItem: "Add New Item",
    agent: "Agent",
    feedback: "Feedback",
    menuManagement: "Menu Management",
  },

  topBar: {
    search: "Search...",
    notifications: "Notifications",
    noNotifications: "No notifications",
    viewAll: "View all",
    profile: "Profile",
    settings: "Settings",
    logout: "Log out",
    userMenu: "User menu",
  },

  notifications: {
    newOrder: "New order received!",
    menuViewed: "Your menu was viewed 25 times today",
    reviewReceived: "You received a new 5-star review",
  },

  organizations: {
    welcome: "Welcome to Restaurant Menu Manager",
    setupDescription:
      "Create your organization to start managing your restaurant menus",
    name: "Organization Name",
    namePlaceholder: "Enter your restaurant name",
    createOrganization: "Create Organization",
  },

  dietaryPreferences: {
    title: "Dietary Preferences",
    subtitle: "Manage dietary preferences for your restaurant menu",
    addPreference: "Add Dietary Preference",
    editPreference: "Edit Dietary Preference",
    deletePreference: "Delete Dietary Preference",
    noPreferences: "No dietary preferences yet. Create one to get started.",
    name: "Name",
    description: "Description",
    icon: "Icon",
    edit: "Edit",
    delete: "Delete",
    save: "Save",
    cancel: "Cancel",
    deleteConfirmation: "Are you sure you want to delete this dietary preference?",
    deleteSuccess: "Dietary preference deleted successfully",
    deleteError: "Failed to delete dietary preference",
    createSuccess: "Dietary preference created successfully",
    createError: "Failed to create dietary preference",
    updateSuccess: "Dietary preference updated successfully",
    updateError: "Failed to update dietary preference",
  },
  menuManagement: {
    title: "Menu Management",
    subtitle: "Configure dietary preferences and ingredients for your menu items",
    tabs: {
      variants: "Variants",
      ingredients: "Ingredients",
      dietaryPreferences: "Dietary Preferences",
      crossSelling: "Cross-Selling"
    },
    ingredientGroups: "Ingredient Groups",
    addIngredientGroup: "Add Ingredient Group",
    editIngredientGroup: "Edit Ingredient Group",
    deleteIngredientGroup: "Delete Ingredient Group",
    addIngredient: "Add Ingredient",
    editIngredient: "Edit Ingredient",
    deleteIngredient: "Delete Ingredient",
    searchIngredientsPlaceholder: "Search ingredients...",
    crossSelling: {
      subtitle: "Manage manual item recommendations",
      noRelations: "No Cross-Selling Configured",
      noRelationsDescription: "Add cross-selling recommendations from the menu item edit modal",
      deleteMessage: "This will remove the manual recommendation. The item may still appear based on calculated scores."
    }
  }
};

